(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulyshine-collection-explore"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-explore-themes')) {
  customElements.define('ss-explore-themes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-explore__track');
      this.controls = this.querySelector('.ss-explore__controls');
      this.dots = this.querySelector('.ss-explore__dots');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        this.go(button.dataset.page !== undefined ? Number(button.dataset.page) : this.page + Number(button.dataset.direction));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.ss-explore__item');
        const index = [...this.track.children].indexOf(item);
        if (index >= 0) this.go(Math.floor(index / this.columns));
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    layout() {
      this.columns = Number(getComputedStyle(this.track).getPropertyValue('--ss-explore-columns'));
      this.pages = Math.ceil(this.track.children.length / this.columns);
      this.controls.hidden = this.pages <= 1;
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-explore__dot'; button.dataset.page = i;
        button.setAttribute('aria-label', `Show collection page ${i + 1} of ${this.pages}`);
        button.setAttribute('aria-controls', this.track.id);
        this.dots.append(button);
      }
      this.update();
    }
    targets() {
      const children = [...this.track.children];
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const step = children.length > 1 ? children[1].offsetLeft - children[0].offsetLeft : this.track.clientWidth;
      return Array.from({length:this.pages}, (_, i) => Math.min(max, i * this.columns * step));
    }
    update() {
      const targets = this.targets();
      this.page = targets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(targets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.page)));
      this.controls.querySelector('[data-direction="-1"]').disabled = this.page === 0;
      this.controls.querySelector('[data-direction="1"]').disabled = this.page >= this.pages - 1;
    }
    go(page) {
      const target = this.targets()[Math.max(0, Math.min(page, this.pages - 1))];
      this.track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulyshine-explore-themes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-explore-themes')) {
  customElements.define('ss-explore-themes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-explore__track');
      this.controls = this.querySelector('.ss-explore__controls');
      this.dots = this.querySelector('.ss-explore__dots');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        this.go(button.dataset.page !== undefined ? Number(button.dataset.page) : this.page + Number(button.dataset.direction));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.ss-explore__item');
        const index = [...this.track.children].indexOf(item);
        if (index >= 0) this.go(Math.floor(index / this.columns));
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    layout() {
      this.columns = Number(getComputedStyle(this.track).getPropertyValue('--ss-explore-columns'));
      this.pages = Math.ceil(this.track.children.length / this.columns);
      this.controls.hidden = this.pages <= 1;
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-explore__dot'; button.dataset.page = i;
        button.setAttribute('aria-label', `Show collection page ${i + 1} of ${this.pages}`);
        button.setAttribute('aria-controls', this.track.id);
        this.dots.append(button);
      }
      this.update();
    }
    targets() {
      const children = [...this.track.children];
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const step = children.length > 1 ? children[1].offsetLeft - children[0].offsetLeft : this.track.clientWidth;
      return Array.from({length:this.pages}, (_, i) => Math.min(max, i * this.columns * step));
    }
    update() {
      const targets = this.targets();
      this.page = targets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(targets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.page)));
      this.controls.querySelector('[data-direction="-1"]').disabled = this.page === 0;
      this.controls.querySelector('[data-direction="1"]').disabled = this.page >= this.pages - 1;
    }
    go(page) {
      const target = this.targets()[Math.max(0, Math.min(page, this.pages - 1))];
      this.track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulyshine-jewelry-themes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-explore-themes')) {
  customElements.define('ss-explore-themes', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-explore__track');
      this.controls = this.querySelector('.ss-explore__controls');
      this.dots = this.querySelector('.ss-explore__dots');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        this.go(button.dataset.page !== undefined ? Number(button.dataset.page) : this.page + Number(button.dataset.direction));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.ss-explore__item');
        const index = [...this.track.children].indexOf(item);
        if (index >= 0) this.go(Math.floor(index / this.columns));
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    layout() {
      this.columns = Number(getComputedStyle(this.track).getPropertyValue('--ss-explore-columns'));
      this.pages = Math.ceil(this.track.children.length / this.columns);
      this.controls.hidden = this.pages <= 1;
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ss-explore__dot'; button.dataset.page = i;
        button.setAttribute('aria-label', `Show collection page ${i + 1} of ${this.pages}`);
        button.setAttribute('aria-controls', this.track.id);
        this.dots.append(button);
      }
      this.update();
    }
    targets() {
      const children = [...this.track.children];
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const step = children.length > 1 ? children[1].offsetLeft - children[0].offsetLeft : this.track.clientWidth;
      return Array.from({length:this.pages}, (_, i) => Math.min(max, i * this.columns * step));
    }
    update() {
      const targets = this.targets();
      this.page = targets.reduce((best, value, i) => Math.abs(value - this.track.scrollLeft) < Math.abs(targets[best] - this.track.scrollLeft) ? i : best, 0);
      [...this.dots.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.page)));
      this.controls.querySelector('[data-direction="-1"]').disabled = this.page === 0;
      this.controls.querySelector('[data-direction="1"]').disabled = this.page >= this.pages - 1;
    }
    go(page) {
      const target = this.targets()[Math.max(0, Math.min(page, this.pages - 1))];
      this.track.scrollTo({ left:target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-trustpilot-review-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openJudgeme(key, done) {
      var t0 = Date.now();
      (function tryOpen() {
        var sec = document.querySelector('[id$="__' + key + '"]');
        var link = sec && sec.querySelector('.jdgm-widget.jdgm--done-setup-widget .jdgm-write-rev-link');
        if (link) {
          // Judge.me builds its popup on the first click of its link: click again until the popup shows (≤ 3 tries)
          var tries = 0;
          (function press() {
            var modal = document.querySelector('.jdgm-write-review-modal');
            if (modal && getComputedStyle(modal).display !== 'none') return done(true);
            if (tries++ >= 3) return done(!!modal);
            link.click();
            setTimeout(press, 400);
          })();
          return;
        }
        if (Date.now() - t0 > 6000) return done(false);
        setTimeout(tryOpen, 250);
      })();
    }
    document.addEventListener('click', function (e) {
      var w = e.target.closest('[data-ss-tpw-write]');
      if (!w) return;
      var key = w.getAttribute('data-ss-tpw-write');
      if (!document.querySelector('[id$="__' + key + '"] .jdgm-widget')) return;   // no Judge.me on this page: follow the link
      e.preventDefault();
      e.stopPropagation();   // Judge.me closes its popup on an outside click: this click must not reach it
      w.setAttribute('aria-busy', 'true');
      setTimeout(function () { openJudgeme(key, function (ok) {
        w.removeAttribute('aria-busy');
        if (!ok) window.open(w.href, '_blank', 'noopener');
      }); }, 0);
    }, true);
  })();
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-tpw-more]');
    if (!btn) return;
    var wall = btn.closest('[data-ss-tpw]');
    if (wall) { wall.classList.add('is-expanded'); btn.parentElement.remove(); }
  });

  } catch(e) { console.error(e); }
})();
})();
